import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div class=\"aditools-card card--main\">\n  <div class=\"aditools-card_header\" ...attributes>{{@title}}</div>\n</div>\n")